export const getLang = (lang, parntProp, prop) => {
  if (lang === "zh") {
    return parntProp[prop];
  } else {
    if (prop == "subtitle") {
      return parntProp["subTitleEn"];
    }
    return parntProp[prop + "En"] || parntProp[prop + "EN"];
  }
};
